import React, { useState, useEffect } from "react";
import { Modal, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import {
  updateAuditStatusApi,
  updateReportStatusApi,
} from "../../../services/AuditService";

const ReportStatus = ({ data, handleAfterUpdate, userPermission }) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("approved");
  const [remark, setRemark] = useState("");
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);

  const handleModalOpen = () => {
    setShowModal(true);
  };

  const handleModalClose = () => {
    setShowModal(false);
    setSelectedStatus("approved");
    setRemark("");
  };

  const handleStatusChange = (event) => {
    setSelectedStatus(event.target.value);
  };

  const handleRemarkChange = (event) => {
    setRemark(event.target.value);
  };

  const handleSubmit = async () => {
    console.log("clicked");
    try {
      setIsSubmitLoading(true);
      const payload = {
        id: data.id,
        status: selectedStatus,
        remarks: remark,
      };
      const response = await updateReportStatusApi(data?.report?.id, payload);
      console.log("status success");
      handleAfterUpdate(response.data.results);
      toast.success(response.data.message);
      handleModalClose();
    } catch (error) {
      console.log("status failed");
      toast.error(error.response?.data?.message);
    } finally {
      setIsSubmitLoading(false);
    }
  };

  return (
    <>
      {/* {data?.status === "pending" ? (
        <span
          className={`badge light border-0 badge-warning badge-sm ${
            userPermission?.approve ? "cursor-pointer" : ""
          }`}
          onClick={userPermission?.approve ? handleModalOpen : undefined}
        >
          Pending
        </span>
      ) : data?.status === "approved" ? (
        <span
          className="badge light border-0 badge-info badge-sm"
        >
          Approved
        </span>
      ) : (
        <span
          className="badge light border-0 badge-danger badge-sm"
        >
          Rejected
        </span>
      )} */}
      {data?.report?.status === "pending" ? (
        <span
          className="badge light border-0 badge-warning badge-sm cursor-pointer"
          onClick={handleModalOpen}
        >
          Pending
        </span>
      ) : data?.report?.status === "approved" ? (
        <span className="badge light border-0 badge-info badge-sm">
          Approved
        </span>
      ) : (
        <span className="badge light border-0 badge-danger badge-sm">
          Rejected
        </span>
      )}

      <Modal show={showModal} centered={true} onHide={handleModalClose}>
        <div className="modal-content">
          <div className="modal-body">
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Select Status:</Form.Label>
                <div className="d-flex align-datas-center gap-3">
                  <Form.Check
                    type="radio"
                    id="approve"
                    label="Approve"
                    name="status"
                    value="approved"
                    checked={selectedStatus === "approved"}
                    onChange={handleStatusChange}
                  />
                  <Form.Check
                    type="radio"
                    id="reject"
                    label="Reject"
                    name="status"
                    value="rejected"
                    checked={selectedStatus === "rejected"}
                    onChange={handleStatusChange}
                  />
                </div>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Remark:</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={remark}
                  onChange={handleRemarkChange}
                  placeholder="Enter your remark here"
                />
              </Form.Group>

              <div className="d-flex align-datas-center justify-content-end">
                <button
                  type="button"
                  className="btn btn-primary me-3"
                  disabled={isSubmitLoading}
                  onClick={handleSubmit}
                >
                  {isSubmitLoading ? "Updating..." : "Update"}
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleModalClose}
                >
                  Cancel
                </button>
              </div>
            </Form>
          </div>
        </div>
      </Modal>
    </>
  );
};

const mapStateToProps = (state) => ({
  userPermission: state.auth.user?.audit_permission,
});
export default connect(mapStateToProps)(ReportStatus);
